<template>
  <b-modal
    id="user-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un utilisateur"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selectedUser">
      <div>
        Supprimer le compte utilisateur de {{selectedUser.lastName}} {{selectedUser.firstName}} ({{selectedUser.username}}) ?
      </div>
      <div>
        Tous les animaux et les hospitalisations associés à cet utilisateur seront également supprimés.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'user-delete-modal',

  props: {
    selectedUser: Object
  },

  emits: ['didDeleteUser'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      api
        .delete(`/user/${this.selectedUser.id}`)
        .then(response => {
          this.$emit('didDeleteUser')
          this.hideModal()
          this.successToast()
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('user-delete-modal')
    },

    successToast() {
      this.$bvToast.toast(`Compte utilisateur supprimé`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/user/UserDeleteModal.vue